import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { Focusable } from 'components/navigation';

export const StyledCategoryItem = styled.div`
  box-sizing: border-box;
  width: ${scaleSize(800)}px;
  height: ${scaleSize(160)}px;
  padding: ${scaleSize(32)}px ${scaleSize(30)}px;
  border-radius: ${scaleSize(8)}px;
`;

export const StyledChannelItem = styled.div`
  height: ${scaleSize(160)}px;
  border-radius: ${scaleSize(8)}px;
`;

export const StyledEPGProgramItemData = styled.div`
  width: ${scaleSize(840)}px;
  height: ${scaleSize(160)}px;
  display: inline-block;
  padding: ${scaleSize(32)}px ${scaleSize(40)}px;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;

  & > span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    color: ${({ isCatchUpAvailable, isActive, isLive, theme }) => {
      if (isActive) return theme.activeColor;

      if (isCatchUpAvailable || isLive) return theme.defaultColor;

      return theme.programTextColor;
    }};
    font-size: ${scaleSize(40)}px;
    line-height: ${scaleSize(48)}px;
    max-width: ${scaleSize(720)}px;
  }

  & > svg path {
    fill: ${({ theme, isCatchUpAvailable, isActive, isLive }) =>
      isActive || isCatchUpAvailable || isLive ? theme.defaultColor : theme.programTextColor};
  }

  & > i {
    white-space: nowrap;
    display: block;
    font-style: normal;
    color: ${({ isCatchUpAvailable, isActive, isLive, theme }) =>
      isCatchUpAvailable || isActive || isLive ? theme.defaultColor : theme.programTextColor};
    font-size: ${scaleSize(34)}px;
    margin-top: ${scaleSize(8)}px;
  }

  & > b {
    position: absolute;
    font-size: ${scaleSize(34)}px;
    bottom: ${scaleSize(32)}px;
    right: ${scaleSize(40)}px;
    text-align: right;
    color: ${({ isCatchUpAvailable, theme }) => {
      return isCatchUpAvailable ? theme.catchUpLabelColor : theme.defaultColor;
    }};

    &:before {
      content: '';
      display: ${({ isLive }) => (isLive ? 'block' : 'none')};
      position: absolute;
      top: ${scaleSize(12)}px;
      left: ${scaleSize(-24)}px;
      width: ${scaleSize(16)}px;
      height: ${scaleSize(16)}px;
      border-radius: ${scaleSize(16)}px;
      background-color: ${({ theme }) => theme.onAirLabelColor};
    }
  }
`;

const img =
  'data:image/png;base64,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';

export const StyledEpgItemWrapper = styled(Focusable)`
  width: ${({ width }) => scaleSize(width || 840)}px;
  height: ${scaleSize(200)}px;
  box-sizing: border-box;
  display: block;
  padding: ${scaleSize(12)}px;
  margin-bottom: -${scaleSize(20)}px;
  border-radius: ${scaleSize(12)}px;
  border: solid ${scaleSize(8)}px transparent;
  opacity: ${({ notAvailable }) => (notAvailable ? 0.5 : 1)};

  &:focus {
    border-color: ${({ theme }) => theme.activeColor};
    &:after {
      width: ${scaleSize(50)}px;
      height: ${scaleSize(70)}px;
      background-image: url(${img});
      background-repeat: no-repeat;
      background-size: ${scaleSize(50)}px ${scaleSize(70)}px;
      display: ${({ type }) => (type !== 'program' ? 'block' : 'none')};
      content: '';
      position: relative;
      top: ${scaleSize(-120)}px;
      left: ${scaleSize(830)}px;
    }
  }
`;
